// extracted by mini-css-extract-plugin
module.exports = {"cursor-follower":"CursorFollower_cursor-follower__B1zTz","pop":"CursorFollower_pop__q3aZY","icon":"CursorFollower_icon__Yx_S6","flip":"CursorFollower_flip__SQWLE"};